import ExportHub from "@/views/export-hub/ExportHub.vue";
import MahallaFundReports from "@/views/mahalla-fund-reports/MahallaFundReports.vue";
import NotificationSettings from "@/views/quarter-fund-notifications/NotificationSettings.vue";
import QuarterFundSubscribers from "@/views/quarter-fund-notifications/QuarterFundSubscribers.vue";
import QuarterFundNotificationLogs from "@/views/quarter-fund-notifications/QuarterFundNotificationLogs.vue";
import ActionLogs from "@/views/action-logs/ActionLogs.vue";
import FinanceCalendarGrid from "@/views/finance-calendar/FinanceCalendarGrid.vue";
import FinanceCalendarDatasetList from "@/views/finance-calendar/DatasetList.vue";
import FinanceCalendarPeriodicityList from "@/views/finance-calendar/PeriodicityList.vue";
import GfsCalendarGrid from "@/views/gfs-calendar/GfsCalendarGrid.vue";
import GfsCalendarDatasetList from "@/views/gfs-calendar/DatasetList.vue";
import GfsCalendarPeriodicityList from "@/views/gfs-calendar/PeriodicityList.vue";
import PsdsCalendarGrid from "@/views/psds-calendar/PsdsCalendarGrid.vue";
import PsdsCalendarDatasetList from "@/views/psds-calendar/DatasetList.vue";
import PsdsCalendarPeriodicityList from "@/views/psds-calendar/PeriodicityList.vue";
import InitiativeList from "@/views/initiatives/InitiativeList.vue";
import BoardList from "@/views/boards/BoardList.vue";
import BoardForm from "@/views/boards/BoardForm.vue";
import BoardVoteSettings from "@/views/boards/BoardVoteSettings.vue";
import BudgetProcessList from "@/views/budget-process/BudgetProcessList.vue";
import BudgetProcessItemForm from "@/views/budget-process/BudgetProcessItemForm.vue";
import QuestionList from "@/views/questions/QuestionList.vue";
import AnswerTemplates from "@/views/questions/AnswerTemplates.vue";
import DistrictBudgetForm from "@/views/district-budget/DistrictBudgetForm.vue";
import QuarterReports from "@/views/quarter-reports/quarter-reports.vue";
import NewsPage from "@/views/news/NewsPage";
import ModeratorNews from "@/views/moderator/ModeratorNews.vue";
import ModeratorRating from "@/views/moderator/ModeratorRating.vue";
import GreenBudget from "@/views/green-budget/list.vue";
import AddNews from "@/views/news/AddNews";
import AddGreenBudget from "@/views/green-budget/add.vue";
import StateBuying from "@/views/state-buyings/list.vue";
import AddStateBuying from "@/views/state-buyings/add.vue";
import QuartersList from "@/views/quarters/QuartersList.vue";
import QuarterForm from "@/views/quarters/QuarterForm.vue";
import RecessMeasured from "@/views/quarters/RecessMeasured.vue";
import QuarterReportAdd from "@/views/quarter-reports/add-reports.vue";
import InitiativeForm from "@/views/initiatives/InitiativeForm.vue";
import ModeratorsList from "@/views/moderator/ModeratorsList.vue";
import ModeratorFormVue from "@/views/moderator/ModeratorForm.vue";
import PopulationList from "@/views/population/PopulationList.vue";
import PopulationForm from "@/views/population/PopulationForm.vue";
import UsersList from "@/views/users/UsersList.vue";
import UserEditFormVue from "@/views/users/UserForm.vue";
import MonitoringUsersList from "@/views/users/MonitoringUsersList.vue";
import MonitoringUserForm from "@/views/users/MonitoringUserForm.vue";
import ModerationResultForm from "@/views/moderation-results/ModerationResultForm.vue";
import RoadView from "@/views/roads/RoadView.vue";
import OrganizationsView from "@/views/organizations/OrganizationsView.vue";
import OpennessOrganizationsList from "@/views/openness-organizations/OpennessOrganizationsList.vue";
import OpennessOrganizationForm from "@/views/openness-organizations/OpennessOrganizationForm.vue";
import OpennessOrganizationReports from "@/views/openness-organizations/OpennessOrganizationReports.vue";
import OpennessOrganizationCategoriesList from "@/views/openness-organizations/categories/OpennessOrganizationCategoriesList.vue";
import OpennessOrganizationCategoryForm from "@/views/openness-organizations/categories/OpennessOrganizationCategoryForm.vue";
import FaqList from "@/views/questions/faq/FaqList.vue";
import FaqForm from "@/views/questions/faq/FaqForm.vue";
import OrderersList from "@/views/chronology/orders/OrderersList.vue";
import OrderersSync from "@/views/chronology/orders/OrderersSync.vue";
import ContractorsSync from "@/views/chronology/contractors/ContractorsSync.vue";
import ContractorsList from "@/views/chronology/contractors/ContractorsList.vue";
import ChronologyList from "@/views/chronology/ChronologyList.vue";
import ChronologyForm from "@/views/chronology/ChronologyForm.vue";
import ChronologyMain from "@/views/newchronology/Main.vue";
import ContactsList from "@/views/contacts/ContactsList.vue";
import ContactsAdd from "@/views/contacts/ContactsAdd.vue";
import StateBudgetList from "@/views/state-budget/StateBudgetList.vue";
import StateBudgetForm from "@/views/state-budget/StateBudgetForm.vue";
import StateBudgetRows from "@/views/state-budget/StateBudgetRows.vue";
import StateBudgetRowForm from "@/views/state-budget/StateBudgetRowForm.vue";
import SuggestionList from "@/views/questions/support-bot/SuggestionList.vue";
import CallMeBackRequests from "@/views/questions/support-bot/CallMeBackRequests.vue";
import BudgetParamsList from "@/views/budget-params/BudgetParamsList.vue";
import BudgetCitizen from "@/views/budget-citizen/budgetCitizen.vue";
import BudgetCitizenForm from "@/views/budget-citizen/budgetCitizenForm.vue";
import BudgetParamsForm from "@/views/budget-params/BudgetParamsForm.vue";
import ForumList from "@/views/forum/ForumList.vue";
// import LogLists from "@/views/lot-lists/LogLists.vue"; // Vaqtincha o'chirilgan
import ForumForm from "@/views/forum/ForumForm.vue";
import ReportSavings from "@/views/reports/Savings.vue";
import ReportSavingForm from "@/views/reports/SavingForm.vue";
import RegionModeratorFormVue from "@/views/moderator/RegionModeratorForm.vue";
import RegionModeratorsList from "@/views/moderator/RegionModeratorsList.vue";
import PublicControl from "@/views/public-control/publicControl.vue";
import Reestor from "@/views/reestor/Reestor.vue";

import ChronologyReports from "@/views/chronologyReports/chronologyReports.vue";
import ProductsView from "@/views/products/productsView.vue";
import ProductsAdd from "@/views/products/productsAdd.vue";
import RegulatoryDocuments from "@/views/regulatory-documents/IndexView.vue";
import RegulatoryDocumentsForm from "@/views/regulatory-documents/FormView.vue";
import DebtDocuments from "@/views/debt-documents/IndexView.vue";
import DebtDocumentsForm from "@/views/debt-documents/FormView.vue";
import FiscalStrategy from "@/views/fiscal-strategy/IndexView.vue";
import FiscalStrategyForm from "@/views/fiscal-strategy/FormView.vue";
import BudgetDocument from "@/views/budget-document/IndexView.vue";
import BudgetDocumentForm from "@/views/budget-document/FormView.vue";
import FiscalRisks from "@/views/fiscal-risks/IndexView.vue";
import FiscalRisksForm from "@/views/fiscal-risks/FormView.vue";
import OrganizationsForm from "@/views/organizations/OrganizationsForm.vue";
import AcceptInitiative from "@/views/moderator/AcceptInitiative.vue";
import PopupList from "@/views/popup/PopupList.vue";
import PopupForm from "@/views/popup/PopupForm.vue";
import GardenPlaces from "@/views/garden-places/list.vue";
import GardenPlaceForm from "@/views/garden-places/GardenPlaceForm.vue";
import IndicatorsList from "@/views/indicators/IndicatorsList.vue";
import IndicatorForm from "@/views/indicators/IndicatorForm.vue";
import CustomersView from "@/views/customer/CustomersView.vue";
import FundList from "@/views/funds/children/FundList.vue";
import FundForm from "@/views/funds/children/FundForm.vue";
import StateTargetFunds from "@/views/funds/StateTargetFunds.vue";
import StateFundForm from "@/views/funds/StateFundForm.vue";
import MinistriesList from "@/views/ministries/MinistriesList.vue";
import MinistryForm from "@/views/ministries/MinistryForm.vue";
import MinistryExecutionList from "@/views/ministries/execution/MinistryExecutionList.vue";
import MinistryExecutionForm from "@/views/ministries/execution/MinistryExecutionForm.vue";
import ExpencesList from "@/views/expence/ExpencesList.vue";
import ExpenseForm from "@/views/expence/ExpenseForm.vue";
import ExpenseIndicatorList from "@/views/expence/indicators/ExpenseIndicatorList.vue";
import ExpenseIndicatorForm from "@/views/expence/indicators/ExpenseIndicatorForm.vue";
import EconomicClassificationList from "@/views/economic/classification/EconomicClassificationList.vue";
import EconomicClassificationForm from "@/views/economic/classification/EconomicClassificationForm.vue";
import EconomicIndicatorList from "@/views/economic/indicators/EconomicIndicatorList.vue";
import StateBudgetExecutionBalanceReportList from "@/views/state-budget-execution-balance-reports/StateBudgetExecutionBalanceReportList.vue";
import StateBudgetExecutionReportList from "@/views/state-budget-execution-reports/StateBudgetExecutionReportList.vue";
import RoadPricesView from "@/views/roads/prices/RoadPricesView.vue";
import RoadPriceForm from "@/views/roads/prices/RoadPriceForm.vue";
import CustomerForm from "@/views/customer/CustomerForm.vue";
import ConsolidatedBudgetList from "@/views/consolidated-budget/ConsolidatedBudgetList.vue";
import ConsolidatedBudgetForm from "@/views/consolidated-budget/ConsolidatedBudgetForm.vue";
import ConsolidatedBudgetIndicatorForm from "@/views/consolidated-budget/indicators/ConsolidatedBudgetIndicatorForm.vue";
import KindergardenView from "@/views/kindergardens/KindergardenView.vue";
import KindergardenForm from "@/views/kindergardens/KindergardenForm.vue";
import QuarterReport from "@/views/quarter-reports/QuarterReport.vue";
import SchoolBoards from "@/views/my-school/board/SchoolBoards.vue";
import SchoolBoardForm from "@/views/my-school/board/SchoolBoardForm.vue";
import SchoolCategories from "@/views/my-school/category/SchoolCategories.vue";
import SchoolCategoryForm from "@/views/my-school/category/SchoolCategoryForm.vue";
import SchoolTemplate from "@/views/my-school/template/SchoolTemplate.vue";
import SchoolTemplateForm from "@/views/my-school/template/SchoolTemplateForm.vue";
import SchoolStudents from "@/views/my-school/student/SchoolStudents.vue";
import SchoolStudentForm from "@/views/my-school/student/SchoolStudentForm.vue";
import InitiativesView from "@/views/my-school/initiatives/InitiativesView.vue";
import SecretKeys from "@/views/my-school/secret-keys/SecretKeys.vue";
import KeyForm from "@/views/my-school/secret-keys/KeyForm.vue";
import SchoolInitiativeForm from "@/views/my-school/initiatives/SchoolInitiativeForm.vue";
import MySchoolInvestSend from "@/views/my-school/invest/MySchoolInvestSend.vue";
import InitiativeCategories from "@/views/initiatives/categories/InitiativeCategories.vue";
import InitiativeCategoryForm from "@/views/initiatives/categories/InitiativeCategoryForm.vue";
import MobileMonitoringList from "@/views/initiatives/mobile-monitoring/MobileMonitoringList.vue";
import MobileMonitoringForm from "@/views/initiatives/mobile-monitoring/MobileMonitoringForm.vue";
import MobileMonitoringReport from "@/views/mobile-monitoring/MobileMonitoringReport.vue";
import StateBudgetIndicatorList from "@/views/state-budget-incomes-expences/StateBudgetIndicatorList.vue";
import StateBudgetQuarterReports from "@/views/state-budget-reports/StateBudgetQuarterReports.vue";
import StateBudgetIndicatorForm from "@/views/state-budget-incomes-expences/StateBudgetIndicatorForm.vue";
import BudgetBySectors from "@/views/sector-state-budget/BudgetBySectors.vue";
import KapitalInvest from "@/views/kapital-invest/index.vue";
import ModeratorNewsForm from "@/views/moderator/ModeratorNewsForm.vue";
import DeputyList from "@/views/deputy/DeputyList.vue";
import DeputyAudit from "@/views/deputy/DeputyAudit.vue";
import OkrugList from "@/views/deputy/OkrugList.vue";
import OkrugQuarters from "@/views/deputy/OkrugQuarters.vue";
import ManagerBoards from "@/views/deputy/manager/ManagerBoards.vue";
import ManagerBoardOkrugs from "@/views/deputy/manager/ManagerBoardOkrugs.vue";
import BoardChosenInitiatives from "@/views/deputy/manager/BoardChosenInitiatives.vue";
import ChosenInitiativesBoards from "@/views/deputy/manager/ChosenInitiativesBoards.vue";
import ManagerLogs from "@/views/deputy/manager/ManagerLogs.vue";
import DeputyManagerList from "@/views/deputy/manager/DeputyManagerList.vue";
import MinistryManagerList from "@/views/ministry-managers/MinistryManagerList.vue";
import MinistryManagerProducts from "@/views/ministry-manager-products/MinistryManagerProducts.vue";
import FractionList from "@/views/deputy/FractionList.vue";
import GfsDataList from "@/views/gfs-data/GfsDataList.vue";
import GfsDataForm from "@/views/gfs-data/GfsDataForm.vue";
import FinancialStatisticMetadataList from "@/views/financial-statistic/metadata/MetadataView.vue";
import FinancialStatisticMetadataForm from "@/views/financial-statistic/metadata/MetadataForm.vue";
import FinancialStatisticPSIT from "@/views/financial-statistic/psit/PSITView.vue";
import FinancialStatisticRevisions from "@/views/financial-statistic/revisions/RevisionsView.vue";
import FinancialStatisticGFSReconciliation from "@/views/financial-statistic/gfs-reconciliation/GfsReconciliationView.vue";
import FinancialStatisticLegalDocumentsList from "@/views/financial-statistic/legal-documents/LegalDocumentsList.vue";
import FinancialStatisticLegalDocumentsForm from "@/views/financial-statistic/legal-documents/LegalDocumentsForm.vue";
import PublicSectorBalanceSheetList from "@/views/financial-statistic/public-sector-balance-sheet/PublicSectorBalanceSheetList.vue";
import PublicSectorBalanceSheetForm from "@/views/financial-statistic/public-sector-balance-sheet/PublicSectorBalanceSheetForm.vue";
import FinanceReports from "@/views/finance-reports/FinanceReports.vue";
import TaxExpendituresList from "@/views/tax-expenditures/TaxExpendituresList.vue";
import TaxExpendituresForm from "@/views/tax-expenditures/TaxExpendituresForm.vue";
import PsdsDataList from "@/views/state-debt/psds-data/PsdsDataList.vue";
import PsdsDataForm from "@/views/state-debt/psds-data/PsdsDataForm.vue";
import LegalDocumentsList from "@/views/state-debt/legal-documents/LegalDocumentsList.vue";
import LegalDocumentsForm from "@/views/state-debt/legal-documents/LegalDocumentsForm.vue";
import DebtDataList from "@/views/state-debt/debt-data/DebtDataList.vue";
import DebtDataForm from "@/views/state-debt/debt-data/DebtDataForm.vue";
import DebtManagementStrategyList from "@/views/state-debt/debt-management-strategy/DebtManagementStrategyList.vue";
import DebtManagementStrategyForm from "@/views/state-debt/debt-management-strategy/DebtManagementStrategyForm.vue";
import InternationalStandardMetadataList from "@/views/state-debt/international-standard-metadata/InternationalStandardMetadataList.vue";
import InternationalStandardMetadataForm from "@/views/state-debt/international-standard-metadata/InternationalStandardMetadataForm.vue";
import ReconciliationList from "@/views/state-debt/reconciliation-national-presentation/ReconciliationList.vue";
import ReconciliationForm from "@/views/state-debt/reconciliation-national-presentation/ReconciliationForm.vue";
import AdminsList from "@/views/admins/AdminsList.vue";
import SubsidiesIndex from "@/views/subsidies/SubsidiesIndex.vue";

const Navigations = [
  {
    main: true,
    isSubmenu: true,
    imgUrl: require("../assets/images/sidebar/home.svg"),
    title: "Tashabbuslar",
    meta: {
      authorize: [
        "admin",
        "moderator",
        "region_manager",
        "district_manager",
        "my_garden_moderator",
      ],
    },
    children: [
      {
        main: true,
        isSubmenu: false,
        imgUrl: require("../assets/images/sidebar/home.svg"),
        title: "Tashabbuslar ro'yxati",
        path: "initiatives",
        name: "Initiatives",
        component: InitiativeList,
        meta: {
          authorize: [
            "admin",
            "moderator",
            "region_manager",
            "district_manager",
            "my_garden_moderator",
          ],
        },
      },
      {
        main: false,
        isSubmenu: false,
        title: "Tashabbusni tasdiqlash",
        path: "initiative/accept/:id/:boardId",
        name: "AcceptInitiative",
        component: AcceptInitiative,
        meta: {
          authorize: [
            "admin",
            "moderator",
            "region_manager",
            "my_garden_moderator",
          ],
        },
      },
      {
        main: true,
        isSubmenu: false,
        imgUrl: require("../assets/images/sidebar/home.svg"),
        title: "Mavsumlar",
        path: "boards",
        name: "BoardsList",
        component: BoardList,
        meta: { authorize: ["admin"] },
      },
      {
        main: false,
        path: "boards/add",
        title: "Mavsum qo'shish",
        name: "BoardsFormAdd",
        component: BoardForm,
        meta: { authorize: ["admin"] },
      },
      {
        main: false,
        path: "boards/edit/:id",
        title: "Mavsumni tahrirlash",
        name: "BoardsFormEdit",
        component: BoardForm,
        meta: { authorize: ["admin"] },
      },
      {
        main: false,
        path: "boards/vote-settings/:id",
        title: "Ovoz berish sozlamasi",
        name: "BoardsVoteSettings",
        component: BoardVoteSettings,
        meta: { authorize: ["admin"] },
      },

      // {
      //   main: true,
      //   isSubmenu: false,
      //   imgUrl: require("../assets/images/sidebar/file-plus.svg"),
      //   path: "moderation-results",
      //   title: "Moderatsiya natijalari",
      //   name: "ModerationResults",
      //   component: ModerationResults,
      //   meta: { authorize: ["admin", "moderator", "region_manager"] },
      // },
      {
        main: true,
        isSubmenu: false,
        imgUrl: require("../assets/images/sidebar/smeta.svg"),
        title: "Tuman budjetini o'zgartirish",
        path: "district-budget",
        name: "DistrictBudget",
        component: DistrictBudgetForm,
        meta: { authorize: ["admin"] },
      },
      {
        main: true,
        isSubmenu: false,
        imgUrl: require("../assets/images/sidebar/home.svg"),
        title: "Kapital invest",
        path: "kapital-invest",
        name: "KapitalInvest",
        component: KapitalInvest,
        meta: { authorize: ["admin"] },
      },

      {
        main: false,
        path: "budget-process/items/add",
        title: "Byudjet jarayoni bandini qo'shish",
        name: "BudgetProcessItemAdd",
        component: BudgetProcessItemForm,
        meta: { authorize: ["admin"] },
      },
      {
        main: false,
        path: "budget-process/items/edit/:id",
        title: "Byudjet jarayoni bandini tahrirlash",
        name: "BudgetProcessItemEdit",
        component: BudgetProcessItemForm,
        meta: { authorize: ["admin"] },
      },
    ],
  },
  {
    main: true,
    isSubmenu: true,
    imgUrl: require("../assets/images/sidebar/reports.svg"),
    title: "Xisobotlar",
    meta: { authorize: ["admin", "region_manager", "moderator", "monitoring"] },
    children: [
      {
        main: true,
        isSubmenu: false,
        imgUrl: require("../assets/images/sidebar/file-plus.svg"),
        title: "Sayyor monitoring",
        path: "mobile-monitoring",
        name: "MobileMonitoringReport",
        component: MobileMonitoringReport,
        meta: { authorize: ["admin", "region_manager", "monitoring"] },
      },
      {
        main: true,
        isSubmenu: false,
        imgUrl: require("../assets/images/sidebar/file-plus.svg"),
        title: "Jamoatchilik nazorati",
        path: "public-control",
        name: "PublicControl",
        component: PublicControl,
        meta: {
          authorize: ["admin", "moderator", "region_manager", "monitoring"],
        },
      },
      {
        main: true,
        isSubmenu: false,
        imgUrl: require("../assets/images/sidebar/file-plus.svg"),
        title: "Xarid Riestorlari",
        path: "reestor",
        name: "Reestor",
        component: Reestor,
        meta: { authorize: ["admin", "moderator", "region_manager"] },
      },

      {
        main: true,
        isSubmenu: false,
        imgUrl: require("../assets/images/sidebar/file-plus.svg"),
        title: "Xronologiya hisobotlar",
        path: "chronology-reports",
        name: "ChronologyReports",
        component: ChronologyReports,
        meta: {
          authorize: ["admin", "moderator", "region_manager", "monitoring"],
        },
      },
      {
        main: true,
        isSubmenu: false,
        imgUrl: require("../assets/images/sidebar/reports.svg"),
        title: "Choraklik hisobotlar",
        path: "quarter-reports",
        name: "QuarterReports",
        component: QuarterReports,
        meta: { authorize: ["admin", "moderator"] },
      },
      {
        main: false,
        path: "quarter-reports/add",
        title: "Choraklik hisobot qo'shish",
        name: "QuarterReportAdd",
        component: QuarterReportAdd,
        meta: { authorize: ["admin", "moderator"] },
      },
      {
        main: false,
        path: "quarter-reports/add/:id",
        title: "Choraklik hisobotni tahrirlash",
        name: "QuarterReportEdit",
        component: QuarterReportAdd,
        meta: { authorize: ["admin", "moderator"] },
      },
      {
        main: true,
        isSubmenu: false,
        imgUrl: require("../assets/images/sidebar/formation_savings.svg"),
        title: "Jamg'arma shakillanishi",
        path: "report-savings",
        name: "Savings",
        component: ReportSavings,
        meta: { authorize: ["admin", "region_manager"] },
      },
      {
        main: false,
        path: "report-savings/edit/:id",
        title: "Jamgarma shakillanishi",
        name: "SavingForm",
        component: ReportSavingForm,
        meta: { authorize: ["admin", "region_manager"] },
      },
      {
        main: true,
        isSubmenu: false,
        imgUrl: require("../assets/images/sidebar/formation_savings.svg"),
        title: "Maxalla budjeti hisoboti",
        path: "quarter-report",
        name: "QuarterReport",
        component: QuarterReport,
        meta: { authorize: ["admin", "moderator"] },
      },
      {
        main: true,
        isSubmenu: false,
        imgUrl: require("../assets/images/sidebar/reports.svg"),
        title: "Mahalla mablag'lari sarfi",
        path: "reports/mahalla-fund-reports",
        name: "MahallaFundReports",
        component: MahallaFundReports,
        meta: { authorize: ["admin"] },
      },
      {
        main: true,
        isSubmenu: false,
        imgUrl: require("../assets/images/sidebar/reports.svg"),
        title: "Excel markazi",
        path: "reports/excel-hub",
        name: "ExportHub",
        component: ExportHub,
        meta: { authorize: ["admin"] },
      },
    ],
  },
  {
    main: true,
    isSubmenu: true,
    imgUrl: require("../assets/images/sidebar/home.svg"),
    title: "Saytni boshqarish",
    meta: { authorize: ["admin"] },
    children: [
      {
        main: true,
        isSubmenu: false,
        imgUrl: require("../assets/images/sidebar/smeta.svg"),
        title: "Mahalliy byudjet",
        path: "finance-reports",
        name: "FinanceReports",
        component: FinanceReports,
        meta: { authorize: ["admin"] },
      },
      {
        main: true,
        isSubmenu: false,
        imgUrl: require("../assets/images/sidebar/comment.svg"),
        title: "Aloqalar",
        name: "QuestionList",
        path: "questions",
        component: QuestionList,
        meta: { authorize: ["admin", "moderator"] },
        // children: [
        //   {
        //     main: true,
        //     isSubmenu: true,
        //     imgUrl: require("../assets/images/sidebar/comment.svg"),
        //     title: "Aloqalar",
        //     meta: { authorize: ["admin", "moderator"] },
        //     children: [
        //       {
        //         main: true,
        //         isSubmenu: false,
        //         imgUrl: require("../assets/images/sidebar/comment.svg"),
        //         title: "Taklif va murojaatlar",
        //         path: "questions",
        //         name: "QuestionList",
        //         component: QuestionList,
        //         meta: { authorize: ["admin"] },
        //       },
        //       {
        //         main: true,
        //         isSubmenu: false,
        //         imgUrl: require("../assets/images/sidebar/envelope-marker.svg"),
        //         title: "Telegram bot orqali takliflar",
        //         path: "suggestions",
        //         name: "SuggestionList",
        //         component: SuggestionList,
        //         meta: { authorize: ["admin", "moderator"] },
        //       },
        //       {
        //         main: true,
        //         isSubmenu: false,
        //         imgUrl: require("../assets/images/sidebar/phone-call.svg"),
        //         title: "Qayta qo'ng'iroq so'rovlari",
        //         path: "cal-me-back",
        //         name: "CallMeBackRequests",
        //         component: CallMeBackRequests,
        //         meta: { authorize: ["admin", "moderator"] },
        //       },
        //       {
        //         main: true,
        //         isSubmenu: false,
        //         imgUrl: require("../assets/images/sidebar/file-plus.svg"),
        //         path: "faq/list",
        //         title: "Tez tez so'raladigan savollar",
        //         name: "FaqList",
        //         component: FaqList,
        //         meta: { authorize: ["admin"] },
        //       },
        //       {
        //         main: false,
        //         path: "faq/edit/:id",
        //         title: "Tez tez so'raladigan savol tahrirlash",
        //         name: "FaqFormEdit",
        //         component: FaqForm,
        //         meta: { authorize: ["admin", "moderator"] },
        //       },
        //       {
        //         main: false,
        //         path: "faq/add",
        //         title: "Tez tez so'raladigan savol qo'shish",
        //         name: "FaqFormAdd",
        //         component: FaqForm,
        //         meta: { authorize: ["admin", "moderator"] },
        //       },
        //     ],
        //   },
        //   {
        //     main: true,
        //     isSubmenu: true,
        //     imgUrl: require("../assets/images/sidebar/smeta.svg"),
        //     title: "Xronologiya",
        //     meta: { authorize: ["admin"] },
        //     children: [
        //       {
        //         main: true,
        //         isSubmenu: false,
        //         imgUrl: require("../assets/images/sidebar/smeta.svg"),
        //         path: "orderers/list",
        //         title: "Buyurtmachilar",
        //         name: "OrderersList",
        //         component: OrderersList,
        //         meta: { authorize: ["admin"] },
        //       },
        //       {
        //         main: false,
        //         path: "orderers/sync",
        //         title: "Buyurtmachilarni yangilash",
        //         name: "OrderersSync",
        //         component: OrderersSync,
        //         meta: { authorize: ["admin"] },
        //       },
        //       {
        //         main: true,
        //         isSubmenu: false,
        //         imgUrl: require("../assets/images/sidebar/smeta.svg"),
        //         path: "contractors/list",
        //         title: "Pudratchilar",
        //         name: "ContractorsList",
        //         component: ContractorsList,
        //         meta: { authorize: ["admin"] },
        //       },
        //       {
        //         main: false,
        //         path: "contractors/sync",
        //         title: "Pudratchilarni yangilash",
        //         name: "ContractorsSync",
        //         component: ContractorsSync,
        //         meta: { authorize: ["admin"] },
        //       },
        //       {
        //         main: false,
        //         path: "chronology-list/:initiativeId",
        //         title: "Tashabbus xronologiyasi",
        //         name: "ChronologyList",
        //         component: ChronologyList,
        //         meta: { authorize: ["admin"] },
        //       },
        //       {
        //         main: false,
        //         path: "chronology-add/:initiativeId",
        //         title: "Xronologiya qo'shish",
        //         name: "ChronologyAdd",
        //         component: ChronologyForm,
        //         meta: { authorize: ["admin"] },
        //       },
        //       {
        //         main: false,
        //         path: "chronology-add/:initiativeId",
        //         title: "Xronologiyani tahrirlash",
        //         name: "ChronologyEdit",
        //         component: ChronologyForm,
        //         meta: { authorize: ["admin"] },
        //       },
        //     ],
        //   },
        //   {
        //     main: true,
        //     isSubmenu: false,
        //     imgUrl: require("../assets/images/sidebar/file-plus.svg"),
        //     title: "Yangiliklar",
        //     path: "news",
        //     name: "NewsPage",
        //     component: NewsPage,
        //     meta: { authorize: ["admin"] },
        //   },
        //   {
        //     main: true,
        //     isSubmenu: false,
        //     imgUrl: require("../assets/images/sidebar/file-plus.svg"),
        //     title: "Indikatorlar",
        //     path: "indicators",
        //     name: "IndicatorsList",
        //     component: IndicatorsList,
        //     meta: { authorize: ["admin"] },
        //   },
        //   {
        //     main: false,
        //     isSubmenu: false,
        //     imgUrl: require("../assets/images/sidebar/file-plus.svg"),
        //     path: "indicator/add",
        //     name: "IndicatorFormAdd",
        //     title: `Indikator qo'shish`,
        //     component: IndicatorForm,
        //     meta: { authorize: ["admin"] },
        //   },
        //   {
        //     main: false,
        //     isSubmenu: false,
        //     imgUrl: require("../assets/images/sidebar/file-plus.svg"),
        //     path: "indicator/edit/:id",
        //     name: "IndicatorFormEdit",
        //     title: `Indikatorni tahrirlash`,
        //     component: IndicatorForm,
        //     meta: { authorize: ["admin"] },
        //   },
        //   {
        //     main: true,
        //     isSubmenu: false,
        //     imgUrl: require("../assets/images/sidebar/file-plus.svg"),
        //     title: "Yashil byudjet",
        //     path: "green-budget",
        //     name: "Green Budget",
        //     component: GreenBudget,
        //     meta: { authorize: ["admin"] },
        //   },
        //   {
        //     main: true,
        //     isSubmenu: false,
        //     imgUrl: require("../assets/images/sidebar/file-plus.svg"),
        //     title: "Davlat xaridlari",
        //     path: "state-buying",
        //     name: "State Buying",
        //     component: StateBuying,
        //     meta: { authorize: ["admin"] },
        //   },
        //   {
        //     main: false,
        //     isSubmenu: false,
        //     imgUrl: require("../assets/images/sidebar/file-plus.svg"),
        //     path: "state-buying/add",
        //     name: "Add State Buying",
        //     title: `Davlat xaridini qo'shish`,
        //     component: AddStateBuying,
        //     meta: { authorize: ["admin"] },
        //   },
        //   {
        //     main: false,
        //     isSubmenu: false,
        //     imgUrl: require("../assets/images/sidebar/file-plus.svg"),
        //     path: "state-buying/add/:id",
        //     name: "Edit State Buying",
        //     title: `Davlat xaridini tahrirlash`,
        //     component: AddStateBuying,
        //     meta: { authorize: ["admin"] },
        //   },
        //   {
        //     main: true,
        //     isSubmenu: false,
        //     imgUrl: require("../assets/images/sidebar/file-plus.svg"),
        //     path: "state-budget/list",
        //     title: "Davlat budjeti",
        //     name: "StateBudgetList",
        //     component: StateBudgetList,
        //     meta: { authorize: ["admin"] },
        //   },
        //   {
        //     main: true,
        //     isSubmenu: false,
        //     imgUrl: require("../assets/images/sidebar/file-plus.svg"),
        //     path: "budget-params",
        //     title: "Budjet parametrlari",
        //     name: "BudgetParams",
        //     component: BudgetParamsList,
        //     meta: { authorize: ["admin"] },
        //   },
        //   {
        //     main: true,
        //     isSubmenu: false,
        //     imgUrl: require("../assets/images/sidebar/file-plus.svg"),
        //     path: "budget-citizen",
        //     title: "Fuqarolar uchun budjet",
        //     name: "BudgetCitizen",
        //     component: BudgetCitizen,
        //     meta: { authorize: ["admin"] },
        //   },
        //   {
        //     main: true,
        //     isSubmenu: false,
        //     imgUrl: require("../assets/images/sidebar/file-plus.svg"),
        //     path: "regulatory-documents",
        //     title: "Normativ hujjatlar",
        //     name: "RegulatoryDocuments",
        //     component: RegulatoryDocuments,
        //     meta: { authorize: ["admin"] },
        //   },
        //   // {
        //   //   main: true,
        //   //   isSubmenu: false,
        //   //   imgUrl: require("../assets/images/sidebar/file-plus.svg"),
        //   //   path: "forum",
        //   //   title: "Muhokama uchrashuvlari",
        //   //   name: "ForumList",
        //   //   component: ForumList,
        //   //   meta: { authorize: ["admin"] },
        //   // },
        // ],
      },
      {
        main: true,
        isSubmenu: false,
        imgUrl: require("../assets/images/sidebar/smeta.svg"),
        title: "Subsidiyalar",
        path: "subsidies",
        name: "SubsidiesIndex",
        component: SubsidiesIndex,
        meta: { authorize: ["admin"] },
      },
      {
        main: true,
        isSubmenu: true,
        imgUrl: require("../assets/images/sidebar/smeta.svg"),
        title: "Xronologiya",
        meta: { authorize: ["admin"] },
        children: [
          {
            main: true,
            isSubmenu: false,
            imgUrl: require("../assets/images/sidebar/smeta.svg"),
            path: "orderers/list",
            title: "Buyurtmachilar",
            name: "OrderersList",
            component: OrderersList,
            meta: { authorize: ["admin"] },
          },
          {
            main: false,
            path: "orderers/sync",
            title: "Buyurtmachilarni yangilash",
            name: "OrderersSync",
            component: OrderersSync,
            meta: { authorize: ["admin"] },
          },
          {
            main: true,
            isSubmenu: false,
            imgUrl: require("../assets/images/sidebar/smeta.svg"),
            path: "contractors/list",
            title: "Pudratchilar",
            name: "ContractorsList",
            component: ContractorsList,
            meta: { authorize: ["admin"] },
          },
          {
            main: false,
            path: "contractors/sync",
            title: "Pudratchilarni yangilash",
            name: "ContractorsSync",
            component: ContractorsSync,
            meta: { authorize: ["admin"] },
          },
          {
            main: false,
            path: "chronology-list/:initiativeId",
            title: "Tashabbus xronologiyasi",
            name: "ChronologyList",
            component: ChronologyList,
            meta: { authorize: ["admin"] },
          },
          {
            main: false,
            path: "chronology-add/:initiativeId",
            title: "Xronologiya qo'shish",
            name: "ChronologyAdd",
            component: ChronologyForm,
            meta: { authorize: ["admin"] },
          },
          {
            main: false,
            path: "chronology-add/:initiativeId",
            title: "Xronologiyani tahrirlash",
            name: "ChronologyEdit",
            component: ChronologyForm,
            meta: { authorize: ["admin"] },
          },
        ],
      },
      {
        main: true,
        isSubmenu: false,
        imgUrl: require("../assets/images/sidebar/file-plus.svg"),
        title: "Yangiliklar",
        path: "news",
        name: "NewsPage",
        component: NewsPage,
        meta: { authorize: ["admin"] },
      },
      {
        main: true,
        isSubmenu: false,
        imgUrl: require("../assets/images/sidebar/file-plus.svg"),
        title: "Indikatorlar",
        path: "indicators",
        name: "IndicatorsList",
        component: IndicatorsList,
        meta: { authorize: ["admin"] },
      },
      {
        main: false,
        isSubmenu: false,
        imgUrl: require("../assets/images/sidebar/file-plus.svg"),
        path: "indicator/add",
        name: "IndicatorFormAdd",
        title: `Indikator qo'shish`,
        component: IndicatorForm,
        meta: { authorize: ["admin"] },
      },
      {
        main: false,
        isSubmenu: false,
        imgUrl: require("../assets/images/sidebar/file-plus.svg"),
        path: "indicator/edit/:id",
        name: "IndicatorFormEdit",
        title: `Indikatorni tahrirlash`,
        component: IndicatorForm,
        meta: { authorize: ["admin"] },
      },
      {
        main: true,
        isSubmenu: false,
        imgUrl: require("../assets/images/sidebar/file-plus.svg"),
        title: "Yashil byudjet",
        path: "green-budget",
        name: "Green Budget",
        component: GreenBudget,
        meta: { authorize: ["admin"] },
      },
      {
        main: true,
        isSubmenu: false,
        imgUrl: require("../assets/images/sidebar/file-plus.svg"),
        title: "Davlat xaridlari",
        path: "state-buying",
        name: "State Buying",
        component: StateBuying,
        meta: { authorize: ["admin"] },
      },
      {
        main: false,
        isSubmenu: false,
        imgUrl: require("../assets/images/sidebar/file-plus.svg"),
        path: "state-buying/add",
        name: "Add State Buying",
        title: `Davlat xaridini qo'shish`,
        component: AddStateBuying,
        meta: { authorize: ["admin"] },
      },
      {
        main: false,
        isSubmenu: false,
        imgUrl: require("../assets/images/sidebar/file-plus.svg"),
        path: "state-buying/add/:id",
        name: "Edit State Buying",
        title: `Davlat xaridini tahrirlash`,
        component: AddStateBuying,
        meta: { authorize: ["admin"] },
      },
      {
        main: true,
        isSubmenu: false,
        imgUrl: require("../assets/images/sidebar/file-plus.svg"),
        path: "state-budget/list",
        title: "Davlat budjeti",
        name: "StateBudgetList",
        component: StateBudgetList,
        meta: { authorize: ["admin"] },
      },
      {
        main: true,
        isSubmenu: false,
        imgUrl: require("../assets/images/sidebar/file-plus.svg"),
        path: "budget-params",
        title: "Budjet parametrlari",
        name: "BudgetParams",
        component: BudgetParamsList,
        meta: { authorize: ["admin"] },
      },
      {
        main: true,
        isSubmenu: false,
        imgUrl: require("../assets/images/sidebar/file-plus.svg"),
        path: "budget-citizen",
        title: "Fuqarolar uchun budjet",
        name: "BudgetCitizen",
        component: BudgetCitizen,
        meta: { authorize: ["admin"] },
      },
      {
        main: true,
        isSubmenu: false,
        imgUrl: require("../assets/images/sidebar/file-plus.svg"),
        path: "regulatory-documents",
        title: "Normativ hujjatlar",
        name: "RegulatoryDocuments",
        component: RegulatoryDocuments,
        meta: { authorize: ["admin"] },
      },
      {
        main: true,
        isSubmenu: false,
        imgUrl: require("../assets/images/sidebar/file-plus.svg"),
        path: "debt-documents",
        title: "Davlat qarzi",
        name: "DebtDocuments",
        component: DebtDocuments,
        meta: { authorize: ["admin"] },
      },
      {
        main: true,
        isSubmenu: false,
        imgUrl: require("../assets/images/sidebar/file-plus.svg"),
        path: "fiscal-strategy",
        title: "Fiscal strategiya",
        name: "FiscalStrategy",
        component: FiscalStrategy,
        meta: { authorize: ["admin"] },
      },
      {
        main: true,
        isSubmenu: false,
        imgUrl: require("../assets/images/sidebar/file-plus.svg"),
        path: "budget-document",
        title: "Budjetnoma",
        name: "BudgetDocument",
        component: BudgetDocument,
        meta: { authorize: ["admin"] },
      },
      {
        main: true,
        isSubmenu: false,
        imgUrl: require("../assets/images/sidebar/file-plus.svg"),
        path: "fiscal-risks",
        title: "Fiskal xatarlar",
        name: "FiscalRisks",
        component: FiscalRisks,
        meta: { authorize: ["admin"] },
      },
      {
        main: true,
        isSubmenu: false,
        imgUrl: require("../assets/images/sidebar/file-plus.svg"),
        path: "forum",
        title: "Muhokama uchrashuvlari",
        name: "ForumList",
        component: ForumList,
        meta: { authorize: ["admin"] },
      },
      // Vaqtincha o'chirilgan
      // {
      //   main: true,
      //   isSubmenu: false,
      //   imgUrl: require("../assets/images/sidebar/file-plus.svg"),
      //   path: "logs",
      //   title: "Loglar",
      //   name: "LogLists",
      //   component: LogLists,
      //   meta: { authorize: ["admin"] },
      // },
      {
        main: true,
        isSubmenu: false,
        imgUrl: require("../assets/images/sidebar/smeta.svg"),
        title: "Byudjet jarayoni",
        path: "budget-process",
        name: "BudgetProcessList",
        component: BudgetProcessList,
        meta: { authorize: ["admin"] },
      },
      {
        main: true,
        isSubmenu: true,
        imgUrl: require("../assets/images/sidebar/smeta.svg"),
        title: "Moliya kalendari",
        meta: { authorize: ["admin"] },
        children: [
          {
            main: true,
            isSubmenu: false,
            imgUrl: require("../assets/images/sidebar/smeta.svg"),
            title: "Kalendar",
            path: "finance-calendar",
            name: "FinanceCalendarGrid",
            component: FinanceCalendarGrid,
            meta: { authorize: ["admin"] },
          },
          {
            main: true,
            isSubmenu: false,
            imgUrl: require("../assets/images/sidebar/reports.svg"),
            title: "Ma'lumot turlari",
            path: "finance-calendar/datasets",
            name: "FinanceCalendarDatasetList",
            component: FinanceCalendarDatasetList,
            meta: { authorize: ["admin"] },
          },
          {
            main: true,
            isSubmenu: false,
            imgUrl: require("../assets/images/sidebar/limit.svg"),
            title: "Davriyliklar",
            path: "finance-calendar/periodicities",
            name: "FinanceCalendarPeriodicityList",
            component: FinanceCalendarPeriodicityList,
            meta: { authorize: ["admin"] },
          },
        ],
      },
      {
        main: true,
        isSubmenu: true,
        imgUrl: require("../assets/images/sidebar/smeta.svg"),
        title: "Davlat moliyaviy statistikasi kalendari",
        meta: { authorize: ["admin"] },
        children: [
          {
            main: true,
            isSubmenu: false,
            imgUrl: require("../assets/images/sidebar/smeta.svg"),
            title: "Kalendar",
            path: "gfs-calendar",
            name: "GfsCalendarGrid",
            component: GfsCalendarGrid,
            meta: { authorize: ["admin"] },
          },
          {
            main: true,
            isSubmenu: false,
            imgUrl: require("../assets/images/sidebar/reports.svg"),
            title: "Ma'lumot turlari",
            path: "gfs-calendar/datasets",
            name: "GfsCalendarDatasetList",
            component: GfsCalendarDatasetList,
            meta: { authorize: ["admin"] },
          },
          {
            main: true,
            isSubmenu: false,
            imgUrl: require("../assets/images/sidebar/limit.svg"),
            title: "Davriyliklar",
            path: "gfs-calendar/periodicities",
            name: "GfsCalendarPeriodicityList",
            component: GfsCalendarPeriodicityList,
            meta: { authorize: ["admin"] },
          },
        ],
      },
      {
        main: true,
        isSubmenu: true,
        imgUrl: require("../assets/images/sidebar/smeta.svg"),
        title: "Davlat sektori qarzi statistikasi kalendari",
        meta: { authorize: ["admin"] },
        children: [
          {
            main: true,
            isSubmenu: false,
            imgUrl: require("../assets/images/sidebar/smeta.svg"),
            title: "Kalendar",
            path: "psds-calendar",
            name: "PsdsCalendarGrid",
            component: PsdsCalendarGrid,
            meta: { authorize: ["admin"] },
          },
          {
            main: true,
            isSubmenu: false,
            imgUrl: require("../assets/images/sidebar/reports.svg"),
            title: "Ma'lumot turlari",
            path: "psds-calendar/datasets",
            name: "PsdsCalendarDatasetList",
            component: PsdsCalendarDatasetList,
            meta: { authorize: ["admin"] },
          },
          {
            main: true,
            isSubmenu: false,
            imgUrl: require("../assets/images/sidebar/limit.svg"),
            title: "Davriyliklar",
            path: "psds-calendar/periodicities",
            name: "PsdsCalendarPeriodicityList",
            component: PsdsCalendarPeriodicityList,
            meta: { authorize: ["admin"] },
          },
        ],
      },
    ],
  },
  {
    main: true,
    isSubmenu: true,
    imgUrl: require("../assets/images/sidebar/home.svg"),
    title: "Spravochnik",
    meta: {
      authorize: [
        "admin",
        "region_manager",
        "my_garden_moderator",
        "deputy_manager",
      ],
    },
    children: [
      {
        main: true,
        isSubmenu: false,
        imgUrl: require("../assets/images/sidebar/file-plus.svg"),
        path: "state-budget/indicators",
        title: "Budjet daromadlari va xarajatlari ko'rsatkichlari",
        name: "StateBudgetIndicatorList",
        component: StateBudgetIndicatorList,
        meta: { authorize: ["admin"] },
      },
      {
        main: true,
        isSubmenu: false,
        imgUrl: require("../assets/images/sidebar/file-plus.svg"),
        path: "state-budget/quarter-report",
        title: "Davlat budjeti daromadlarining choraklik hisobotlari",
        name: "StateBudgetQuarterReports",
        component: StateBudgetQuarterReports,
        meta: { authorize: ["admin"] },
      },
      {
        main: false,
        path: "state-budget/indicator/add",
        title: "Budjet daromadlari va xarajatlari ko'rsatkichini qo'shish",
        name: "StateBudgetIndicatorFormAdd",
        component: StateBudgetIndicatorForm,
        meta: { authorize: ["admin"] },
      },
      {
        main: false,
        path: "state-budget/indicator/add/:parent",
        title: "Budjet daromadlari va xarajatlari ko'rsatkichini qo'shish",
        name: "StateBudgetIndicatorParentFormAdd",
        component: StateBudgetIndicatorForm,
        meta: { authorize: ["admin"] },
      },
      {
        main: false,
        path: "state-budget/indicator/edit/:id/:parent",
        title: "Budjet daromadlari va xarajatlari ko'rsatkichini tahrirlash",
        name: "StateBudgetIndicatorFormEdit",
        component: StateBudgetIndicatorForm,
        meta: { authorize: ["admin"] },
      },
      {
        main: true,
        isSubmenu: false,
        imgUrl: require("../assets/images/sidebar/file-plus.svg"),
        title: "Soliq xarajatlari",
        path: "tax-expenditures",
        name: "TaxExpendituresList",
        component: TaxExpendituresList,
        meta: { authorize: ["admin"] },
      },
      {
        main: false,
        path: "tax-expenditures/add",
        title: "Soliq xarajati qo'shish",
        name: "TaxExpendituresAdd",
        component: TaxExpendituresForm,
        meta: { authorize: ["admin"] },
      },
      {
        main: false,
        path: "tax-expenditures/edit/:id",
        title: "Soliq xarajatini tahrirlash",
        name: "TaxExpendituresEdit",
        component: TaxExpendituresForm,
        meta: { authorize: ["admin"] },
      },
      {
        main: true,
        isSubmenu: false,
        imgUrl: require("../assets/images/sidebar/file-plus.svg"),
        path: "initiative-categories",
        title: "Tashabbus kategoriyalari",
        name: "InitiativeCategories",
        component: InitiativeCategories,
        meta: { authorize: ["admin"] },
      },
      {
        main: false,
        path: "initiative-category/add",
        title: "Tashabbus kategoriyasini qo'shish",
        name: "InitiativeCategoryFormAdd",
        component: InitiativeCategoryForm,
        meta: { authorize: ["admin"] },
      },
      {
        main: false,
        path: "initiative-category/edit/:id",
        title: "Tashabbus kategoriyasini tahrirlash",
        name: "InitiativeCategoryFormEdit",
        component: InitiativeCategoryForm,
        meta: { authorize: ["admin"] },
      },
      {
        main: true,
        isSubmenu: false,
        imgUrl: require("../assets/images/sidebar/file-plus.svg"),
        path: "ministries",
        title: "Vazirliklar",
        name: "MinistriesList",
        component: MinistriesList,
        meta: { authorize: ["admin"] },
      },
      {
        main: false,
        path: "ministry/add",
        title: "Vazirlik qo'shish",
        name: "MinistryFormAdd",
        component: MinistryForm,
        meta: { authorize: ["admin"] },
      },
      {
        main: false,
        path: "ministry/edit/:id",
        title: "Vazirlikni tahrirlash",
        name: "MinistryFormEdit",
        component: MinistryForm,
        meta: { authorize: ["admin"] },
      },
      {
        main: true,
        isSubmenu: false,
        imgUrl: require("../assets/images/sidebar/file-plus.svg"),
        path: "ministry/execution",
        title: "Vazirliklar ijrosi",
        name: "MinistryExecutionList",
        component: MinistryExecutionList,
        meta: { authorize: ["admin"] },
      },
      {
        main: false,
        path: "ministry/execution/add",
        title: "Vazirlik ijrosini qo'shish",
        name: "MinistryExecutionFormAdd",
        component: MinistryExecutionForm,
        meta: { authorize: ["admin"] },
      },
      {
        main: false,
        path: "ministry/execution/edit/:id",
        title: "Vazirlik ijrosini tahrirlash",
        name: "MinistryExecutionFormEdit",
        component: MinistryExecutionForm,
        meta: { authorize: ["admin"] },
      },
      {
        main: true,
        isSubmenu: false,
        imgUrl: require("../assets/images/sidebar/file-plus.svg"),
        path: "expenses",
        title: "Xarajatlar",
        name: "ExpencesList",
        component: ExpencesList,
        meta: { authorize: ["admin"] },
      },
      {
        main: false,
        path: "expense/add",
        title: "Xarajat qo'shish",
        name: "ExpenseFormAdd",
        component: ExpenseForm,
        meta: { authorize: ["admin"] },
      },
      {
        main: false,
        path: "expense/edit/:id",
        title: "Xarajatni tahrirlash",
        name: "ExpenseFormEdit",
        component: ExpenseForm,
        meta: { authorize: ["admin"] },
      },
      {
        main: false,
        isSubmenu: false,
        imgUrl: require("../assets/images/sidebar/file-plus.svg"),
        path: "expense-indicators",
        title: "Xarajatlar ko'rsatgichi",
        name: "ExpenseIndicatorList",
        component: ExpenseIndicatorList,
        meta: { authorize: ["admin"] },
      },
      {
        main: false,
        path: "expense-indicator/add",
        title: "Xarajat ko'rsatgichini qo'shish",
        name: "ExpenseIndicatorFormAdd",
        component: ExpenseIndicatorForm,
        meta: { authorize: ["admin"] },
      },
      {
        main: false,
        path: "expense-indicator/edit/:id",
        title: "Xarajat ko'rsatgichini tahrirlash",
        name: "ExpenseIndicatorFormEdit",
        component: ExpenseIndicatorForm,
        meta: { authorize: ["admin"] },
      },
      {
        main: true,
        isSubmenu: false,
        imgUrl: require("../assets/images/sidebar/file-plus.svg"),
        path: "economic-classifications",
        title: "Iqtisodiy klassifikatorlar",
        name: "EconomicClassificationList",
        component: EconomicClassificationList,
        meta: { authorize: ["admin"] },
      },
      {
        main: false,
        path: "economic-classification/add",
        title: "Iqtisodiy klassifikator qo'shish",
        name: "EconomicClassificationFormAdd",
        component: EconomicClassificationForm,
        meta: { authorize: ["admin"] },
      },
      {
        main: false,
        path: "economic-classification/edit/:id",
        title: "Iqtisodiy klassifikatorni tahrirlash",
        name: "EconomicClassificationFormEdit",
        component: EconomicClassificationForm,
        meta: { authorize: ["admin"] },
      },
      {
        main: true,
        isSubmenu: false,
        imgUrl: require("../assets/images/sidebar/file-plus.svg"),
        path: "economic-classification/indicators",
        title: "Iqtisodiy klassifikator ko'rsatgichlar",
        name: "EconomicIndicatorList",
        component: EconomicIndicatorList,
        meta: { authorize: ["admin"] },
      },
      {
        main: true,
        isSubmenu: false,
        imgUrl: require("../assets/images/sidebar/file-plus.svg"),
        path: "state-budget-execution-balance-reports",
        title: "Davlat budjeti ijrosining balansi",
        name: "StateBudgetExecutionBalanceReportList",
        component: StateBudgetExecutionBalanceReportList,
        meta: { authorize: ["admin"] },
      },
      {
        main: true,
        isSubmenu: false,
        imgUrl: require("../assets/images/sidebar/file-plus.svg"),
        path: "state-budget-execution-reports",
        title: "Davlat budjeti ijrosining hisoboti",
        name: "StateBudgetExecutionReportList",
        component: StateBudgetExecutionReportList,
        meta: { authorize: ["admin"] },
      },

      {
        main: true,
        isSubmenu: false,
        imgUrl: require("../assets/images/sidebar/file-plus.svg"),
        path: "funds",
        title: "Jamg'armalar",
        name: "FundList",
        component: FundList,
        meta: { authorize: ["admin"] },
      },
      {
        main: false,
        path: "fund/add",
        title: "Jamg'arma qo'shish",
        name: "FundFormAdd",
        component: FundForm,
        meta: { authorize: ["admin"] },
      },
      {
        main: false,
        path: "fund/edit/:id",
        title: "Jamg'armani tahrirlash",
        name: "FundFormEdit",
        component: FundForm,
        meta: { authorize: ["admin"] },
      },
      {
        main: true,
        isSubmenu: false,
        imgUrl: require("../assets/images/sidebar/file-plus.svg"),
        path: "consolidated-budget",
        title: "Konsolidatsiyalashgan budjet",
        name: "ConsolidatedBudgetList",
        component: ConsolidatedBudgetList,
        meta: { authorize: ["admin"] },
      },
      {
        main: false,
        path: "consolidated-budget/add",
        title: "Konsolidatsiyalashgan budjet qo'shish",
        name: "ConsolidatedBudgetFormAdd",
        component: ConsolidatedBudgetForm,
        meta: { authorize: ["admin"] },
      },
      {
        main: false,
        path: "consolidated-budget/edit/:id",
        title: "Konsolidatsiyalashgan budjet tahrirlash",
        name: "ConsolidatedBudgetFormEdit",
        component: ConsolidatedBudgetForm,
        meta: { authorize: ["admin"] },
      },
      {
        main: false,
        path: "consolidated-budget/indicator/add/:budget_id",
        title: "Indikator qo'shish",
        name: "ConsolidatedBudgetIndicatorFormAdd",
        component: ConsolidatedBudgetIndicatorForm,
        meta: { authorize: ["admin"] },
      },
      {
        main: false,
        path: "consolidated-budget/indicator/add/:id/:budget_id",
        title: "Indikatorni tahrirlash",
        name: "ConsolidatedBudgetIndicatorFormEdit",
        component: ConsolidatedBudgetIndicatorForm,
        meta: { authorize: ["admin"] },
      },
      {
        main: true,
        isSubmenu: false,
        imgUrl: require("../assets/images/sidebar/file-plus.svg"),
        path: "kindergardens",
        title: "Bog'chalar",
        name: "KindergardenView",
        component: KindergardenView,
        meta: { authorize: ["admin", "region_manager"] },
      },
      {
        main: false,
        path: "kindergarden/add",
        title: "Bog'cha qo'shish",
        name: "KindergardenFormAdd",
        component: KindergardenForm,
        meta: { authorize: ["admin", "region_manager"] },
      },
      {
        main: false,
        path: "kindergarden/edit/:id",
        title: "Bog'chani tahrirlash",
        name: "KindergardenFormEdit",
        component: KindergardenForm,
        meta: { authorize: ["admin", "region_manager"] },
      },
      {
        main: true,
        isSubmenu: false,
        imgUrl: require("../assets/images/sidebar/file-plus.svg"),
        path: "state-target-funds",
        title: "Maqsadli jamg'armalar",
        name: "StateTargetFunds",
        component: StateTargetFunds,
        meta: { authorize: ["admin"] },
      },
      {
        main: false,
        path: "state-target-fund/add",
        title: "Maqsadli jamg'arma qo'shish",
        name: "StateFundFormAdd",
        component: StateFundForm,
        meta: { authorize: ["admin"] },
      },
      {
        main: false,
        path: "state-target-fund/edit/:id",
        title: "Maqsadli jamg'armani tahrirlash",
        name: "StateFundFormEdit",
        component: StateFundForm,
        meta: { authorize: ["admin"] },
      },
      {
        main: true,
        isSubmenu: false,
        imgUrl: require("../assets/images/sidebar/file-plus.svg"),
        title: "Bog' maydonlari",
        path: "garden-places",
        name: "Garden Places",
        component: GardenPlaces,
        meta: { authorize: ["admin", "my_garden_moderator"] },
      },
      {
        main: false,
        isSubmenu: false,
        imgUrl: require("../assets/images/sidebar/file-plus.svg"),
        path: "garden-place/add",
        name: "AddGardenPlace",
        title: `Bog' maydonini qo'shish`,
        component: GardenPlaceForm,
        meta: { authorize: ["admin", "my_garden_moderator"] },
      },
      {
        main: false,
        isSubmenu: false,
        imgUrl: require("../assets/images/sidebar/file-plus.svg"),
        path: "garden-place/edit/:id",
        name: "EditGardenPlace",
        title: `Bog' maydonini tahrirlash`,
        component: GardenPlaceForm,
        meta: { authorize: ["admin", "my_garden_moderator"] },
      },
      {
        main: true,
        isSubmenu: false,
        imgUrl: require("../assets/images/sidebar/file-plus.svg"),
        title: "Yo'l narxlari",
        path: "road-prices",
        name: "Road Prices",
        component: RoadPricesView,
        meta: { authorize: ["admin"] },
      },
      {
        main: false,
        isSubmenu: false,
        imgUrl: require("../assets/images/sidebar/file-plus.svg"),
        path: "road-price/add",
        name: "RoadPriceFormAdd",
        title: `Yo'l narxini qo'shish`,
        component: RoadPriceForm,
        meta: { authorize: ["admin"] },
      },
      {
        main: false,
        isSubmenu: false,
        imgUrl: require("../assets/images/sidebar/file-plus.svg"),
        path: "road-price/edit/:id",
        name: "RoadPriceFormEdit",
        title: `Yo'l narxini tahrirlash`,
        component: RoadPriceForm,
        meta: { authorize: ["admin"] },
      },
      {
        main: true,
        isSubmenu: false,
        imgUrl: require("../assets/images/sidebar/file-plus.svg"),
        path: "customers",
        title: "Buyurtmachilar",
        name: "CustomersView",
        component: CustomersView,
        meta: { authorize: ["admin"] },
      },
      {
        main: false,
        isSubmenu: false,
        imgUrl: require("../assets/images/sidebar/file-plus.svg"),
        path: "customer/add",
        name: "CustomerFormAdd",
        title: `Buyurtmachi qo'shish`,
        component: CustomerForm,
        meta: { authorize: ["admin"] },
      },
      {
        main: false,
        isSubmenu: false,
        imgUrl: require("../assets/images/sidebar/file-plus.svg"),
        path: "customer/edit/:id",
        name: "CustomerFormEdit",
        title: `Buyurtmachini tahrirlash`,
        component: CustomerForm,
        meta: { authorize: ["admin"] },
      },
      {
        main: true,
        isSubmenu: true,
        imgUrl: require("../assets/images/sidebar/file-plus.svg"),
        title: "Tovarlar",
        meta: { authorize: ["admin", "ministry_manager"] },
        children: [
          {
            main: true,
            isSubmenu: false,
            imgUrl: require("../assets/images/sidebar/file-plus.svg"),
            path: "products/list",
            title: "Tovarlar",
            name: "ProductsView",
            component: ProductsView,
            meta: { authorize: ["admin"] },
          },
          {
            main: false,
            path: "products/add",
            title: "Tovar qo'shish",
            name: "ProductsAdd",
            component: ProductsAdd,
            meta: { authorize: ["admin"] },
          },
          {
            main: false,
            path: "products/edit/:id",
            title: "Tovarni tahrirlash",
            name: "ProductsEdit",
            component: ProductsAdd,
            meta: { authorize: ["admin"] },
          },

          // FRONTEND_ADMIN_PRODUCTS.md §5.1 — the legacy product-categories
          // ("Kategoriyalar") screen is no longer part of the product flow
          // (products bind directly to initiative_categories). Hidden from the
          // sidebar AND removed as a reachable route. Code kept behind this flag
          // (and the CategoriesView/CategoriesAdd imports below) so it is a
          // one-line re-enable if the decision is revisited; backend endpoints
          // (/product-categories) are untouched.
          // {
          //   main: true,
          //   isSubmenu: false,
          //   imgUrl: require("../assets/images/sidebar/file-plus.svg"),
          //   path: "categories/list",
          //   title: "Kategoriyalar",
          //   name: "categoriesView",
          //   component: CategoriesView,
          //   meta: { authorize: ["admin"] },
          // },
          // {
          //   main: false,
          //   path: "categories/add",
          //   title: "Kategoriya qo'shish",
          //   name: "CategoriesAdd",
          //   component: CategoriesAdd,
          //   meta: { authorize: ["admin"] },
          // },
          // {
          //   main: false,
          //   path: "categories/edit/:id",
          //   title: "Kategoriyani tahrirlash",
          //   name: "CategoriesEdit",
          //   component: CategoriesAdd,
          //   meta: { authorize: ["admin"] },
          // },
          {
            main: true,
            isSubmenu: false,
            imgUrl: require("../assets/images/sidebar/file-plus.svg"),
            path: "ministry-manager-products",
            title: "Vazirlik mahsulotlari",
            name: "MinistryManagerProducts",
            component: MinistryManagerProducts,
            meta: { authorize: ["admin", "ministry_manager"] },
          },
        ],
      },

      {
        main: true,
        isSubmenu: false,
        imgUrl: require("../assets/images/sidebar/user-profile-add.svg"),
        title: "Aholi Soni",
        path: "population",
        name: "PopulationList",
        component: PopulationList,
        meta: { authorize: ["admin", "moderator", "region_manager"] },
      },
      {
        main: false,
        path: "population/add",
        title: "Aholi qo'shish",
        name: "PopulationAdd",
        component: PopulationForm,
        meta: { authorize: ["admin", "moderator", "region_manager"] },
      },
      {
        main: false,
        path: "population/edit/:id",
        title: "Aholi sonini tahrirlash",
        name: "PopulationEdit",
        component: PopulationForm,
        meta: { authorize: ["admin", "moderator", "region_manager"] },
      },

      {
        main: true,
        isSubmenu: false,
        imgUrl: require("../assets/images/sidebar/user-profile-add.svg"),
        title: "Kontaktlar",
        path: "contacts",
        name: "ContactsList",
        component: ContactsList,
        meta: { authorize: ["admin"] },
      },
      {
        main: true,
        isSubmenu: false,
        imgUrl: require("../assets/images/sidebar/file-plus.svg"),
        path: "organizations",
        title: "Tashkilotlar",
        name: "OrganizationsView",
        component: OrganizationsView,
        meta: { authorize: ["admin"] },
      },

      {
        main: false,
        path: "organizations/add",
        title: "Tashkilot qo'shish",
        name: "OrganizationAdd",
        component: OrganizationsForm,
        meta: { authorize: ["admin"] },
      },

      {
        main: true,
        isSubmenu: false,
        imgUrl: require("../assets/images/sidebar/file-plus.svg"),
        title: "Mahallalar",
        path: "quarters",
        name: "QuartersList",
        component: QuartersList,
        meta: { authorize: ["admin", "region_manager", "moderator"] },
      },
      {
        main: true,
        isSubmenu: false,
        imgUrl: require("../assets/images/sidebar/file-plus.svg"),
        path: "roads",
        title: "Yaroqsiz holatdagi yo'llar",
        name: "RoadView",
        component: RoadView,
        meta: { authorize: ["admin"] },
      },
      {
        main: true,
        isSubmenu: false,
        imgUrl: require("../assets/images/sidebar/file-plus.svg"),
        path: "answer-templates",
        title: "Savol-Javob shabloni",
        name: "AnswerTemplates",
        component: AnswerTemplates,
        meta: { authorize: ["admin"] },
      },
      {
        main: true,
        isSubmenu: false,
        imgUrl: require("../assets/images/sidebar/organ.svg"),
        path: "openness-organizations",
        title: "Budjet jarayonining ochiqligi reytingi",
        name: "OpennessOrganizationsList",
        component: OpennessOrganizationsList,
        meta: { authorize: ["admin"] },
      },
      {
        main: false,
        path: "openness-organizations/add",
        title: "Tashkilot qo'shish",
        name: "OpennessOrganizationFormAdd",
        component: OpennessOrganizationForm,
        meta: { authorize: ["admin"] },
      },
      {
        main: false,
        path: "openness-organizations/edit/:id",
        title: "Tashkilotni tahrirlash",
        name: "OpennessOrganizationFormEdit",
        component: OpennessOrganizationForm,
        meta: { authorize: ["admin"] },
      },
      {
        main: false,
        path: "openness-organizations/:id/reports",
        title: "Tashkilot hisobotlari",
        name: "OpennessOrganizationReports",
        component: OpennessOrganizationReports,
        meta: { authorize: ["admin"] },
      },
      {
        main: true,
        isSubmenu: false,
        imgUrl: require("../assets/images/sidebar/file-plus.svg"),
        path: "openness-organization-categories",
        title: "Tashkilot kategoriyalari",
        name: "OpennessOrganizationCategoriesList",
        component: OpennessOrganizationCategoriesList,
        meta: { authorize: ["admin"] },
      },
      {
        main: false,
        path: "openness-organization-categories/add",
        title: "Kategoriya qo'shish",
        name: "OpennessOrganizationCategoryFormAdd",
        component: OpennessOrganizationCategoryForm,
        meta: { authorize: ["admin"] },
      },
      {
        main: false,
        path: "openness-organization-categories/edit/:id",
        title: "Kategoriyani tahrirlash",
        name: "OpennessOrganizationCategoryFormEdit",
        component: OpennessOrganizationCategoryForm,
        meta: { authorize: ["admin"] },
      },
      {
        main: true,
        isSubmenu: true,
        imgUrl: require("../assets/images/sidebar/user-profile-add.svg"),
        title: "Deputatlar",
        meta: { authorize: ["admin", "deputy_manager"] },
        children: [
          // {
          //   main: true,
          //   isSubmenu: false,
          //   imgUrl: require("../assets/images/sidebar/user-profile-add.svg"),
          //   title: "Deputatlarni boshqarish",
          //   path: "deputies",
          //   name: "DeputyList",
          //   component: DeputyList,
          //   meta: { authorize: ["admin"] },
          // },
          {
            main: true,
            isSubmenu: false,
            imgUrl: require("../assets/images/sidebar/user-profile-add.svg"),
            title: "Okruglarni boshqarish",
            path: "deputy-manager/boards",
            name: "ManagerBoards",
            component: ManagerBoards,
            meta: { authorize: ["admin", "deputy_manager"] },
          },
          {
            main: false,
            path: "deputy-manager/board/:boardId/okrugs",
            title: "Okruglar bo'yicha deputatlar",
            name: "ManagerBoardOkrugs",
            component: ManagerBoardOkrugs,
            meta: { authorize: ["admin", "deputy_manager"] },
          },
          {
            main: true,
            isSubmenu: false,
            imgUrl: require("../assets/images/sidebar/user-profile-add.svg"),
            title: "Loyihalar ijrosi",
            path: "deputy-manager/chosen-initiatives",
            name: "ChosenInitiativesBoards",
            component: ChosenInitiativesBoards,
            meta: { authorize: ["admin", "deputy_manager"] },
          },
          {
            main: false,
            path: "deputy-manager/board/:boardId/chosen-initiatives",
            title: "Loyihalar ijrosi",
            name: "BoardChosenInitiatives",
            component: BoardChosenInitiatives,
            meta: { authorize: ["admin", "deputy_manager"] },
          },
          {
            main: true,
            isSubmenu: false,
            imgUrl: require("../assets/images/sidebar/user-profile-add.svg"),
            title: "Okruglar",
            path: "deputy/okrugs",
            name: "DeputyOkrugList",
            component: OkrugList,
            meta: { authorize: ["admin"] },
          },
          {
            main: false,
            path: "deputy/okrug/:id/quarters",
            title: "Okrug mahallalari",
            name: "DeputyOkrugQuarters",
            component: OkrugQuarters,
            meta: { authorize: ["admin"] },
          },
          {
            main: true,
            isSubmenu: false,
            imgUrl: require("../assets/images/sidebar/user-profile-add.svg"),
            title: "Fraksiyalar",
            path: "deputy/fractions",
            name: "FractionList",
            component: FractionList,
            meta: { authorize: ["admin"] },
          },
        ],
      },
    ],
  },
  {
    main: true,
    isSubmenu: true,
    imgUrl: require("../assets/images/sidebar/file-plus.svg"),
    title: "Saytga dostup berish",
    meta: { authorize: ["admin"] },
    children: [
      {
        main: true,
        isSubmenu: false,
        imgUrl: require("../assets/images/sidebar/user-profile-add.svg"),
        title: "Adminlar",
        path: "admins",
        name: "AdminsList",
        component: AdminsList,
        meta: { authorize: ["admin"] },
      },
      {
        main: true,
        isSubmenu: false,
        imgUrl: require("../assets/images/sidebar/user-profile-add.svg"),
        title: "Moderatorlar",
        path: "moderators",
        name: "ModeratorsList",
        component: ModeratorsList,
        meta: { authorize: ["admin"] },
      },
      {
        main: false,
        path: "moderator/add",
        title: "Moderator qo'shish",
        name: "ModeratorAdd",
        component: ModeratorFormVue,
        meta: { authorize: ["admin"] },
      },
      {
        main: false,
        path: "moderator/edit/:id",
        title: "Moderatorni tahrirlash",
        name: "ModeratorEdit",
        component: ModeratorFormVue,
        meta: { authorize: ["admin"] },
      },
      {
        main: false,
        path: "deputy/audit",
        title: "Deputat audit",
        name: "DeputyAudit",
        component: DeputyAudit,
        meta: { authorize: ["admin"] },
      },
      {
        main: true,
        isSubmenu: false,
        imgUrl: require("../assets/images/sidebar/reports.svg"),
        title: "Amallar jurnali",
        path: "action-logs",
        name: "ActionLogs",
        component: ActionLogs,
        meta: { authorize: ["admin"] },
      },
      {
        main: true,
        isSubmenu: false,
        imgUrl: require("../assets/images/sidebar/user-profile-add.svg"),
        title: "Deputat menejerlari",
        path: "deputy-manager/managers",
        name: "DeputyManagerList",
        component: DeputyManagerList,
        meta: { authorize: ["admin"] },
      },
      {
        main: true,
        isSubmenu: false,
        imgUrl: require("../assets/images/sidebar/user-profile-add.svg"),
        title: "Vazirlik menejerlari",
        path: "ministry-managers",
        name: "MinistryManagerList",
        component: MinistryManagerList,
        meta: { authorize: ["admin"] },
      },
      {
        // Hidden route — admin-only, reached via the "Loglar" button on the
        // Deputat menejerlari page.
        main: false,
        path: "deputy-manager/logs",
        title: "Biriktirish loglari",
        name: "ManagerLogs",
        component: ManagerLogs,
        meta: { authorize: ["admin"] },
      },
      {
        main: true,
        isSubmenu: false,
        imgUrl: require("../assets/images/sidebar/user-profile-add.svg"),
        title: "Foydalanuvchilar",
        path: "users",
        name: "UsersList",
        component: UsersList,
        meta: { authorize: ["admin"] },
      },
      {
        main: false,
        path: "user/edit/:id",
        title: "Foydalanuvchini tahrirlash",
        name: "UserForm",
        component: UserEditFormVue,
        meta: { authorize: ["admin"] },
      },
      {
        main: true,
        isSubmenu: false,
        imgUrl: require("../assets/images/sidebar/user-profile-add.svg"),
        title: "Monitoring foydalanuvchilar",
        path: "monitoring-users",
        name: "MonitoringUsersList",
        component: MonitoringUsersList,
        meta: { authorize: ["admin"] },
      },
      {
        main: false,
        path: "monitoring-user/create",
        title: "Monitoring foydalanuvchi qo'shish",
        name: "MonitoringUserCreate",
        component: MonitoringUserForm,
        meta: { authorize: ["admin"] },
      },
      {
        main: false,
        path: "monitoring-user/edit/:id",
        title: "Monitoring foydalanuvchini tahrirlash",
        name: "MonitoringUserEdit",
        component: MonitoringUserForm,
        meta: { authorize: ["admin"] },
      },
      {
        main: true,
        isSubmenu: false,
        imgUrl: require("../assets/images/sidebar/user-profile-add.svg"),
        title: "Region Moderatorlar",
        path: "region-moderators",
        name: "RegionModeratorsList",
        component: RegionModeratorsList,
        meta: { authorize: ["admin"] },
      },
      {
        main: false,
        path: "region_moderator/add",
        title: "Region Moderator qo'shish",
        name: "RegionModeratorAdd",
        component: RegionModeratorFormVue,
        meta: { authorize: ["admin"] },
      },
      {
        main: false,
        path: "region_moderator/edit/:id",
        title: "Region Moderatorni tahrirlash",
        name: "RegionModeratorEdit",
        component: RegionModeratorFormVue,
        meta: { authorize: ["admin"] },
      },
    ],
  },
  {
    main: true,
    isSubmenu: true,
    imgUrl: require("../assets/images/sidebar/home.svg"),
    title: "Mening maktabim",
    meta: { authorize: ["admin", "moderator", "region_manager"] },
    children: [
      {
        main: true,
        isSubmenu: false,
        imgUrl: require("../assets/images/sidebar/file-plus.svg"),
        path: "school-boards",
        title: "Doskalar",
        name: "SchoolBoards",
        component: SchoolBoards,
        meta: { authorize: ["admin"] },
      },
      {
        main: false,
        path: "school-board/add",
        title: "Doska qo'shish",
        name: "SchoolBoardFormAdd",
        component: SchoolBoardForm,
        meta: { authorize: ["admin"] },
      },
      {
        main: false,
        path: "school-board/edit/:id",
        title: "Doskani tahrirlash",
        name: "SchoolBoardFormEdit",
        component: SchoolBoardForm,
        meta: { authorize: ["admin"] },
      },
      {
        main: true,
        isSubmenu: false,
        imgUrl: require("../assets/images/sidebar/file-plus.svg"),
        path: "school-categories",
        title: "Tashabbus kategoriyalari",
        name: "SchoolCategories",
        component: SchoolCategories,
        meta: { authorize: ["admin"] },
      },
      {
        main: false,
        path: "school-initiative-category/add",
        title: "Tashabbus kategoriyasini qo'shish",
        name: "SchoolCategoryFormAdd",
        component: SchoolCategoryForm,
        meta: { authorize: ["admin"] },
      },
      {
        main: false,
        path: "school-initiative-category/edit/:id",
        title: "Tashabbus kategoriyasini tahrirlash",
        name: "SchoolCategoryFormEdit",
        component: SchoolCategoryForm,
        meta: { authorize: ["admin"] },
      },
      {
        main: true,
        isSubmenu: false,
        imgUrl: require("../assets/images/sidebar/file-plus.svg"),
        path: "school-templates",
        title: "Shablonlar",
        name: "SchoolTemplate",
        component: SchoolTemplate,
        meta: { authorize: ["admin"] },
      },
      {
        main: false,
        path: "school-template/add",
        title: "Shablon qo'shish",
        name: "SchoolTemplateFormAdd",
        component: SchoolTemplateForm,
        meta: { authorize: ["admin"] },
      },
      {
        main: false,
        path: "school-template/edit/:id",
        title: "Shablonni tahrirlash",
        name: "SchoolTemplateFormEdit",
        component: SchoolTemplateForm,
        meta: { authorize: ["admin"] },
      },
      {
        main: true,
        isSubmenu: false,
        imgUrl: require("../assets/images/sidebar/file-plus.svg"),
        path: "school-students",
        title: "O'quvchilar",
        name: "SchoolStudents",
        component: SchoolStudents,
        meta: { authorize: ["admin"] },
      },
      {
        main: false,
        path: "school-student/add",
        title: "O'quvchi qo'shish",
        name: "SchoolStudentFormAdd",
        component: SchoolStudentForm,
        meta: { authorize: ["admin"] },
      },
      {
        main: false,
        path: "school-student/edit/:id",
        title: "O'quvchini tahrirlash",
        name: "SchoolStudentFormEdit",
        component: SchoolStudentForm,
        meta: { authorize: ["admin"] },
      },
      {
        main: true,
        isSubmenu: false,
        imgUrl: require("../assets/images/sidebar/file-plus.svg"),
        path: "school-initiatives",
        title: "Tashabbuslar",
        name: "SchoolInitiatives",
        component: InitiativesView,
        meta: { authorize: ["admin", "moderator", "region_manager"] },
      },
      {
        main: false,
        path: "my-school/initiative/add",
        title: "Tashabbus qo'shish",
        name: "SchoolInitiativeFormAdd",
        component: SchoolInitiativeForm,
        meta: { authorize: ["admin"] },
      },
      {
        main: true,
        isSubmenu: false,
        imgUrl: require("../assets/images/sidebar/file-plus.svg"),
        path: "school/invest-send",
        title: "Invest tizimiga yuborish",
        name: "MySchoolInvestSend",
        component: MySchoolInvestSend,
        meta: { authorize: ["admin"] },
      },
      {
        main: true,
        isSubmenu: false,
        imgUrl: require("../assets/images/sidebar/file-plus.svg"),
        path: "school/secret-keys",
        title: "Kalit so'zlar",
        name: "SecretKeys",
        component: SecretKeys,
        meta: { authorize: ["admin"] },
      },
      {
        main: false,
        path: "school/secret-keys/add",
        title: "Kalit qo'shish",
        name: "KeyFormAdd",
        component: KeyForm,
        meta: { authorize: ["admin"] },
      },
      {
        main: false,
        path: "school/secret-keys/edit/:id",
        title: "Kalitni tahrirlash",
        name: "KeyFormEdit",
        component: KeyForm,
        meta: { authorize: ["admin"] },
      },
    ],
  },

  {
    main: false,
    title: "Tashabbusni tahrirlash",
    path: "initiative/edit/:id",
    name: "InitiativeEdit",
    component: InitiativeForm,
    meta: { authorize: ["admin"] },
  },
  {
    main: false,
    title: "Shaffof invest malumotlar",
    path: "newchronology/:public_id",
    name: "ChronologyMain",
    component: ChronologyMain,
    meta: { authorize: ["admin", "moderator"] },
  },

  {
    main: false,
    isSubmenu: false,
    imgUrl: require("../assets/images/sidebar/file-plus.svg"),
    path: "news/add",
    name: "AddNews",
    title: `Yangilik qo'shish`,
    component: AddNews,
    meta: { authorize: ["admin"] },
  },
  {
    main: false,
    isSubmenu: false,
    imgUrl: require("../assets/images/sidebar/file-plus.svg"),
    path: "green-budget/add",
    name: "Add Green Budget",
    title: `Yashil byudjet qo'shish`,
    component: AddGreenBudget,
    meta: { authorize: ["admin"] },
  },
  {
    main: false,
    isSubmenu: false,
    imgUrl: require("../assets/images/sidebar/file-plus.svg"),
    path: "news/add/:id",
    name: "UpdateNews",
    title: `Yangilik taxrirlash`,
    component: AddNews,
    meta: { authorize: ["admin"] },
  },
  {
    main: false,
    isSubmenu: false,
    imgUrl: require("../assets/images/sidebar/file-plus.svg"),
    path: "green-budget/add/:id",
    name: "Update green Budget",
    title: `Yashil byudjet taxrirlash`,
    component: AddGreenBudget,
    meta: { authorize: ["admin"] },
  },

  {
    main: false,
    path: "contacts/add",
    title: "Kontakt qo'shish",
    name: "ContactsAdd",
    component: ContactsAdd,
    meta: { authorize: ["admin"] },
  },

  {
    main: false,
    path: "contacts/edit/:id",
    title: "Kontaktni tahrirlash",
    name: "ContactsEdit",
    component: ContactsAdd,
    meta: { authorize: ["admin"] },
  },

  {
    main: false,
    path: "quarters/recess-measured",
    title: "Tanaffus hisobi",
    name: "RecessMeasured",
    component: RecessMeasured,
    meta: { authorize: ["admin"] },
  },
  {
    main: false,
    path: "quarter/add",
    title: "Mahalla qo'shish",
    name: "QuarterAdd",
    component: QuarterForm,
    meta: { authorize: ["admin"] },
  },
  {
    main: false,
    path: "quarter/edit/:id",
    title: "Mahallani tahrirlash",
    name: "QuarterEdit",
    component: QuarterForm,
    meta: { authorize: ["admin"] },
  },

  {
    main: false,
    path: "moderation-results/add",
    title: "Moderatsiya natijasini qo'shish",
    name: "AddModerationResult",
    component: ModerationResultForm,
    meta: { authorize: ["admin", "moderator"] },
  },
  {
    main: false,
    path: "moderation-results/edit/:id",
    title: "Moderatsiya natijasini tahrirlash",
    name: "EditModerationResult",
    component: ModerationResultForm,
    meta: { authorize: ["admin", "moderator"] },
  },

  {
    main: false,
    path: "state-budget/add",
    title: "Davlat budjeti turi qo'shish",
    name: "SateBudgetAdd",
    component: StateBudgetForm,
    meta: { authorize: ["admin"] },
  },
  {
    main: false,
    path: "state-budget/rows/:stateBudgetId",
    title: "Davlat budjeti ma'lumotlari",
    name: "StateBudgetRows",
    component: StateBudgetRows,
    meta: { authorize: ["admin"] },
  },
  {
    main: false,
    path: "state-budget/rows/add",
    title: "Davlat budjeti ma'lumotiga qator qo'shish",
    name: "SateBudgetRowAdd",
    component: StateBudgetRowForm,
    meta: { authorize: ["admin"] },
  },
  {
    main: false,
    path: "state-budget/rows/edit/:id",
    title: "Davlat budjeti ma'lumoti qatorini tahrirlash",
    name: "SateBudgetRowEdit",
    component: StateBudgetRowForm,
    meta: { authorize: ["admin"] },
  },
  {
    main: false,
    path: "budget-params/add",
    title: "Budjet parametri qo'shish",
    name: "BudgetParamAdd",
    component: BudgetParamsForm,
    meta: { authorize: ["admin"] },
  },
  {
    main: false,
    path: "budget-params/edit/:id",
    title: "Budjet parametrini tahrirlash",
    name: "BudgetParamEdit",
    component: BudgetParamsForm,
    meta: { authorize: ["admin"] },
  },
  {
    main: false,
    path: "budget-citizen/add",
    title: "Fuqarolar uchun budjet qo'shish",
    name: "BudgetCitizenAdd",
    component: BudgetCitizenForm,
    meta: { authorize: ["admin"] },
  },
  {
    main: false,
    path: "budget-citizen/edit/:id",
    title: "Fuqarolar uchun budjetni tahrirlash",
    name: "BudgetCitizenEdit",
    component: BudgetCitizenForm,
    meta: { authorize: ["admin"] },
  },
  {
    main: false,
    path: "regulatory-documents/add",
    title: "Normativ hujjatlar qo'shish",
    name: "RegulatoryDocumentsAdd",
    component: RegulatoryDocumentsForm,
    meta: { authorize: ["admin"] },
  },

  {
    main: false,
    path: "regulatory-documents/edit/:id",
    title: "Normativ hujjatlarni tahrirlash",
    name: "RegulatoryDocumentsEdit",
    component: RegulatoryDocumentsForm,
    meta: { authorize: ["admin"] },
  },
  {
    main: false,
    path: "debt-documents/add",
    title: "Davlat qarzi qo'shish",
    name: "DebtDocumentsAdd",
    component: DebtDocumentsForm,
    meta: { authorize: ["admin"] },
  },
  {
    main: false,
    path: "debt-documents/edit/:id",
    title: "Davlat qarzini tahrirlash",
    name: "DebtDocumentsEdit",
    component: DebtDocumentsForm,
    meta: { authorize: ["admin"] },
  },
  {
    main: false,
    path: "fiscal-strategy/add",
    title: "Fiscal strategiya qo'shish",
    name: "FiscalStrategyAdd",
    component: FiscalStrategyForm,
    meta: { authorize: ["admin"] },
  },
  {
    main: false,
    path: "fiscal-strategy/edit/:id",
    title: "Fiscal strategiyani tahrirlash",
    name: "FiscalStrategyEdit",
    component: FiscalStrategyForm,
    meta: { authorize: ["admin"] },
  },
  {
    main: false,
    path: "budget-document/add",
    title: "Budjetnoma qo'shish",
    name: "BudgetDocumentAdd",
    component: BudgetDocumentForm,
    meta: { authorize: ["admin"] },
  },
  {
    main: false,
    path: "budget-document/edit/:id",
    title: "Budjetnomani tahrirlash",
    name: "BudgetDocumentEdit",
    component: BudgetDocumentForm,
    meta: { authorize: ["admin"] },
  },
  {
    main: false,
    path: "fiscal-risks/add",
    title: "Fiskal xatar hujjati qo'shish",
    name: "FiscalRisksAdd",
    component: FiscalRisksForm,
    meta: { authorize: ["admin"] },
  },
  {
    main: false,
    path: "fiscal-risks/edit/:id",
    title: "Fiskal xatar hujjatini tahrirlash",
    name: "FiscalRisksEdit",
    component: FiscalRisksForm,
    meta: { authorize: ["admin"] },
  },
  {
    main: false,
    path: "forum/add",
    title: "Muhokama uchrashuv kiritish",
    name: "ForumAdd",
    component: ForumForm,
    meta: { authorize: ["admin"] },
  },
  {
    main: false,
    path: "forum/edit/:id",
    title: "Muhokama uchrashuini tahririlash",
    name: "ForumEdit",
    component: ForumForm,
    meta: { authorize: ["admin"] },
  },
  {
    main: true,
    isSubmenu: true,
    imgUrl: require("../assets/images/sidebar/home.svg"),
    title: "Mobile ilovani boshqarish",
    meta: { authorize: ["admin"] },
    children: [
      {
        main: true,
        isSubmenu: false,
        imgUrl: require("../assets/images/sidebar/file-plus.svg"),
        title: "Moderator yangiliklar",
        path: "moderator-news",
        name: "ModeratorNewsPage",
        component: ModeratorNews,
        meta: { authorize: ["admin"] },
      },
      {
        main: false,
        isSubmenu: false,
        imgUrl: require("../assets/images/sidebar/file-plus.svg"),
        title: "Moderator yangilik qo'shish",
        path: "moderator-news/add",
        name: "ModeratorNewsForm",
        component: ModeratorNewsForm,
        meta: { authorize: ["admin"] },
      },
      {
        main: false,
        isSubmenu: false,
        imgUrl: require("../assets/images/sidebar/file-plus.svg"),
        path: "moderator-news/add/:id",
        name: "UpdateModeratorNews",
        title: `Moderator yangilik taxrirlash`,
        component: ModeratorNewsForm,
        meta: { authorize: ["admin"] },
      },
      {
        main: true,
        isSubmenu: false,
        imgUrl: require("../assets/images/sidebar/file-plus.svg"),
        title: "Top moderatorlar",
        path: "top-moderatorlar",
        name: "ModeratorRating",
        component: ModeratorRating,
        meta: { authorize: ["admin"] },
      },
    ],
  },
  {
    main: true,
    isSubmenu: false,
    imgUrl: require("../assets/images/sidebar/file-plus.svg"),
    path: "popups",
    title: "Popup",
    name: "PopupList",
    component: PopupList,
    meta: { authorize: ["admin"] },
  },
  {
    main: false,
    path: "popup/add",
    name: "PopupFormAdd",
    component: PopupForm,
    meta: { authorize: ["admin"] },
  },
  {
    main: false,
    path: "popup/edit/:id",
    name: "PopupFormEdit",
    component: PopupForm,
    meta: { authorize: ["admin"] },
  },
  {
    main: false,
    isSubmenu: false,
    imgUrl: require("../assets/images/sidebar/file-plus.svg"),
    path: "mobile-monitoring/:initiative",
    title: "Sayyor monitoring",
    name: "MobileMonitoringList",
    component: MobileMonitoringList,
    meta: { authorize: ["admin", "moderator"] },
  },
  {
    main: false,
    path: "mobile-monitoring/add/:initiative",
    name: "MobileMonitoringFormAdd",
    component: MobileMonitoringForm,
    meta: { authorize: ["admin"] },
  },
  {
    main: false,
    path: "mobile-monitoring/edit/:id",
    name: "MobileMonitoringFormEdit",
    component: MobileMonitoringForm,
    meta: { authorize: ["admin"] },
  },
  // {
  //     main: true,
  //     isSubmenu: false,
  //     imgUrl: require("../assets/images/sidebar/file-plus.svg"),
  //     path: "by-sectors",
  //     title: "Sohalar kesimida",
  //     name: "BudgetBySectors",
  //     component: BudgetBySectors,
  //     meta: {authorize: ["admin"]},
  // },

  {
    main: true,
    isSubmenu: true,
    imgUrl: require("../assets/images/sidebar/file-plus.svg"),
    title: "Davlat moliyaviy statistikasi",
    meta: { authorize: ["admin"] },
    children: [
      {
        main: true,
        isSubmenu: false,
        imgUrl: require("../assets/images/sidebar/file-plus.svg"),
        title: "GFS ma'lumotlar",
        path: "gfs-data",
        name: "GfsDataList",
        component: GfsDataList,
        meta: { authorize: ["admin"] },
      },
      {
        main: false,
        path: "gfs-data/add",
        title: "GFS ma'lumot qo'shish",
        name: "GfsDataAdd",
        component: GfsDataForm,
        meta: { authorize: ["admin"] },
      },
      {
        main: false,
        path: "gfs-data/edit/:id",
        title: "GFS ma'lumotni tahrirlash",
        name: "GfsDataEdit",
        component: GfsDataForm,
        meta: { authorize: ["admin"] },
      },
      {
        main: true,
        isSubmenu: false,
        imgUrl: require("../assets/images/sidebar/file-plus.svg"),
        title: "Metadata",
        path: "financial-statistic-metadata",
        name: "FinancialStatisticMetadataList",
        component: FinancialStatisticMetadataList,
        meta: { authorize: ["admin"] },
      },
      {
        main: false,
        path: "financial-statistic-metadata/add",
        title: "Metadata qo'shish",
        name: "FinancialStatisticMetadataAdd",
        component: FinancialStatisticMetadataForm,
        meta: { authorize: ["admin"] },
      },
      {
        main: false,
        path: "financial-statistic-metadata/edit/:id",
        title: "Metadatani tahrirlash",
        name: "FinancialStatisticMetadataEdit",
        component: FinancialStatisticMetadataForm,
        meta: { authorize: ["admin"] },
      },
      {
        main: true,
        isSubmenu: false,
        imgUrl: require("../assets/images/sidebar/file-plus.svg"),
        title: "PSIT",
        path: "financial-statistic-psit",
        name: "FinancialStatisticPSIT",
        component: FinancialStatisticPSIT,
        meta: { authorize: ["admin"] },
      },
      {
        main: true,
        isSubmenu: false,
        imgUrl: require("../assets/images/sidebar/file-plus.svg"),
        title: "Revisions",
        path: "financial-statistic-revisions",
        name: "FinancialStatisticRevisions",
        component: FinancialStatisticRevisions,
        meta: { authorize: ["admin"] },
      },
      {
        main: true,
        isSubmenu: false,
        imgUrl: require("../assets/images/sidebar/file-plus.svg"),
        title: "Reconciliation of National Presentation with GFS",
        path: "financial-statistic-gfs-reconciliation",
        name: "FinancialStatisticGFSReconciliation",
        component: FinancialStatisticGFSReconciliation,
        meta: { authorize: ["admin"] },
      },
      {
        main: true,
        isSubmenu: false,
        imgUrl: require("../assets/images/sidebar/file-plus.svg"),
        title: "Qonunchilik hujjatlari",
        path: "financial-statistic-legal-documents",
        name: "FinancialStatisticLegalDocumentsList",
        component: FinancialStatisticLegalDocumentsList,
        meta: { authorize: ["admin"] },
      },
      {
        main: false,
        path: "financial-statistic-legal-documents/add",
        title: "Qonunchilik hujjati qo'shish",
        name: "FinancialStatisticLegalDocumentsAdd",
        component: FinancialStatisticLegalDocumentsForm,
        meta: { authorize: ["admin"] },
      },
      {
        main: false,
        path: "financial-statistic-legal-documents/edit/:id",
        title: "Qonunchilik hujjatini tahrirlash",
        name: "FinancialStatisticLegalDocumentsEdit",
        component: FinancialStatisticLegalDocumentsForm,
        meta: { authorize: ["admin"] },
      },
      {
        main: true,
        isSubmenu: false,
        imgUrl: require("../assets/images/sidebar/file-plus.svg"),
        title: "Davlat sektori balans hisoboti",
        path: "financial-statistic-public-sector-balance-sheet",
        name: "PublicSectorBalanceSheetList",
        component: PublicSectorBalanceSheetList,
        meta: { authorize: ["admin"] },
      },
      {
        main: false,
        path: "financial-statistic-public-sector-balance-sheet/add",
        title: "Balans hisoboti qo'shish",
        name: "PublicSectorBalanceSheetAdd",
        component: PublicSectorBalanceSheetForm,
        meta: { authorize: ["admin"] },
      },
      {
        main: false,
        path: "financial-statistic-public-sector-balance-sheet/edit/:id",
        title: "Balans hisobotini tahrirlash",
        name: "PublicSectorBalanceSheetEdit",
        component: PublicSectorBalanceSheetForm,
        meta: { authorize: ["admin"] },
      },
    ],
  },
  {
    main: true,
    isSubmenu: true,
    imgUrl: require("../assets/images/sidebar/file-plus.svg"),
    title: "Davlat sektori qarzi statistikasi",
    meta: { authorize: ["admin"] },
    children: [
      {
        main: true,
        isSubmenu: false,
        imgUrl: require("../assets/images/sidebar/file-plus.svg"),
        title: "DSQS ma'lumotlari",
        path: "psds-data",
        name: "PsdsDataList",
        component: PsdsDataList,
        meta: { authorize: ["admin"] },
      },
      {
        main: false,
        path: "psds-data/add",
        title: "DSQS ma'lumot qo'shish",
        name: "PsdsDataAdd",
        component: PsdsDataForm,
        meta: { authorize: ["admin"] },
      },
      {
        main: false,
        path: "psds-data/edit/:id",
        title: "PSDS ma'lumotni tahrirlash",
        name: "PsdsDataEdit",
        component: PsdsDataForm,
        meta: { authorize: ["admin"] },
      },
      {
        main: true,
        isSubmenu: false,
        imgUrl: require("../assets/images/sidebar/file-plus.svg"),
        title: "Huquqiy hujjatlar",
        path: "legal-documents",
        name: "LegalDocumentsList",
        component: LegalDocumentsList,
        meta: { authorize: ["admin"] },
      },
      {
        main: false,
        path: "legal-documents/add",
        title: "Huquqiy hujjat qo'shish",
        name: "LegalDocumentsAdd",
        component: LegalDocumentsForm,
        meta: { authorize: ["admin"] },
      },
      {
        main: false,
        path: "legal-documents/edit/:id",
        title: "Huquqiy hujjatni tahrirlash",
        name: "LegalDocumentsEdit",
        component: LegalDocumentsForm,
        meta: { authorize: ["admin"] },
      },
      {
        main: true,
        isSubmenu: false,
        imgUrl: require("../assets/images/sidebar/file-plus.svg"),
        title: "Davlat qarzi ma'lumotlari",
        path: "debt-data",
        name: "DebtDataList",
        component: DebtDataList,
        meta: { authorize: ["admin"] },
      },
      {
        main: false,
        path: "debt-data/add",
        title: "Davlat qarzi ma'lumoti qo'shish",
        name: "DebtDataAdd",
        component: DebtDataForm,
        meta: { authorize: ["admin"] },
      },
      {
        main: false,
        path: "debt-data/edit/:id",
        title: "Davlat qarzi ma'lumotini tahrirlash",
        name: "DebtDataEdit",
        component: DebtDataForm,
        meta: { authorize: ["admin"] },
      },
      {
        main: true,
        isSubmenu: false,
        imgUrl: require("../assets/images/sidebar/file-plus.svg"),
        title: "Davlat qarzini boshqarish strategiyasi",
        path: "debt-management-strategy",
        name: "DebtManagementStrategy",
        component: DebtManagementStrategyList,
        meta: { authorize: ["admin"] },
      },
      {
        main: false,
        path: "debt-management-strategy/add",
        title: "Strategiya fayli qo'shish",
        name: "DebtManagementStrategyAdd",
        component: DebtManagementStrategyForm,
        meta: { authorize: ["admin"] },
      },
      {
        main: false,
        path: "debt-management-strategy/edit/:id",
        title: "Strategiya faylini tahrirlash",
        name: "DebtManagementStrategyEdit",
        component: DebtManagementStrategyForm,
        meta: { authorize: ["admin"] },
      },
      {
        main: true,
        isSubmenu: false,
        imgUrl: require("../assets/images/sidebar/file-plus.svg"),
        title: "Xalqaro standartlar metadatasi",
        path: "international-standard-metadata",
        name: "InternationalStandardMetadataList",
        component: InternationalStandardMetadataList,
        meta: { authorize: ["admin"] },
      },
      {
        main: false,
        path: "international-standard-metadata/add",
        title: "Metadata qo'shish",
        name: "InternationalStandardMetadataAdd",
        component: InternationalStandardMetadataForm,
        meta: { authorize: ["admin"] },
      },
      {
        main: false,
        path: "international-standard-metadata/edit/:id",
        title: "Metadatani tahrirlash",
        name: "InternationalStandardMetadataEdit",
        component: InternationalStandardMetadataForm,
        meta: { authorize: ["admin"] },
      },
      {
        main: true,
        isSubmenu: false,
        imgUrl: require("../assets/images/sidebar/file-plus.svg"),
        title: "Milliy taqdimot bilan muvofiqlashtirish",
        path: "reconciliation-national-presentation",
        name: "ReconciliationList",
        component: ReconciliationList,
        meta: { authorize: ["admin"] },
      },
      {
        main: false,
        path: "reconciliation-national-presentation/add",
        title: "Ma'lumot qo'shish",
        name: "ReconciliationAdd",
        component: ReconciliationForm,
        meta: { authorize: ["admin"] },
      },
      {
        main: false,
        path: "reconciliation-national-presentation/edit/:id",
        title: "Ma'lumotni tahrirlash",
        name: "ReconciliationEdit",
        component: ReconciliationForm,
        meta: { authorize: ["admin"] },
      },
    ],
  },
  {
    main: true,
    isSubmenu: true,
    imgUrl: require("../assets/images/sidebar/envelope-marker.svg"),
    title: "Bildirishnomalar",
    meta: { authorize: ["admin"] },
    children: [
      {
        main: true,
        isSubmenu: false,
        imgUrl: require("../assets/images/sidebar/envelope-marker.svg"),
        title: "Bildirishnoma turlari",
        path: "notifications/settings",
        name: "NotificationSettings",
        component: NotificationSettings,
        meta: { authorize: ["admin"] },
      },
      {
        main: true,
        isSubmenu: false,
        imgUrl: require("../assets/images/sidebar/user-profile-add.svg"),
        title: "Jamg'arma obunachilari",
        path: "notifications/subscribers",
        name: "QuarterFundSubscribers",
        component: QuarterFundSubscribers,
        meta: { authorize: ["admin"] },
      },
      {
        main: true,
        isSubmenu: false,
        imgUrl: require("../assets/images/sidebar/file-plus.svg"),
        title: "Yuborish jurnali",
        path: "notifications/logs",
        name: "QuarterFundNotificationLogs",
        component: QuarterFundNotificationLogs,
        meta: { authorize: ["admin"] },
      },
    ],
  },
];
export default Navigations;
